// @TODO add logic to compile endpoint based on env variables

const config = {
  // development
  // apiEndpoint: 'http://localhost:3000/',
  // production
  apiEndpoint: 'http://162.243.218.207/',
  fontName: 'orbitron',
  blackColor: 0x000000,
  greyColor: 0x565758,
  whiteColor: 0xFFFFFF,
  warriorBlue: 0x3353ff,
  redColor: 0xfc2241,
  greenColor: 0x4ad89c,
  darkBlue: 0x001899,
  warriorLightBlue: 0x637af9,
  yellowColor: 0xfab606,
  thunderOrange: 0xf45130,
  lakerPurple: 0x7f54a4,
  hornetGreen: 0x2989a0,
};

export default config;



/** WEBPACK FOOTER **
 ** ./assets/js/src/config/config.js
 **/